import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

const methods = [
  { icon: "ri-focus-3-line", title: "先看细节", text: "把画面还原成可核对的时间线与证据链" },
  { icon: "ri-check-double-line", title: "再作验证", text: "小道消息要交叉比对，不轻信单方说法" },
  { icon: "ri-task-line", title: "最后结论", text: "摆出多种可能，把判断留给理性的你" },
];

export default function DeepDigSection() {
  const shendu = articles.filter((a) => a.category === "shendu");
  const [first, second] = shendu;

  return (
    <section className="bg-background-800 text-background-100 border-b border-background-900">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs tracking-[0.2em] text-accent-300 font-medium">
              <i className="ri-search-line"></i>
              DEEP DIG · 深度挖掘
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-background-50">
              未删细节与隐藏线索的主战场
            </h2>
            <p className="mt-2 max-w-2xl text-sm text-background-100/70 leading-6">
              用镜头语言、时间码与道具线索说话，把被忽略的蛛丝马迹逐格展开。
            </p>
          </div>
          <Link to="/channel/shendu" className="inline-flex items-center gap-1.5 text-sm font-medium text-accent-300 hover:text-accent-200 whitespace-nowrap">
            全部深度挖掘
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {first && (
          <Link to={`/article/${first.id}`} className="group mt-8 grid grid-cols-1 lg:grid-cols-2 overflow-hidden rounded-2xl bg-background-900/60 hover:bg-background-900 transition-colors">
            <div className="relative h-64 lg:h-auto overflow-hidden">
              <img src={first.image} alt={first.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            </div>
            <div className="flex flex-col justify-center p-6 md:p-10">
              <span className="text-xs text-accent-300 flex items-center gap-2">
                <i className="ri-flashlight-line"></i>
                本期重点复盘
              </span>
              <h3 className="mt-3 font-heading text-xl md:text-2xl font-bold text-background-50 leading-snug group-hover:text-accent-200 transition-colors">
                {first.title}
              </h3>
              <p className="mt-3 text-sm leading-7 text-background-100/75">{first.subtitle}</p>
              <div className="mt-5 flex items-center gap-4 text-xs text-background-100/60">
                <span className="flex items-center gap-1.5"><i className="ri-user-3-line"></i>{first.author}</span>
                <span>{first.date}</span>
                <span>{first.readTime}</span>
              </div>
            </div>
          </Link>
        )}

        {second && (
          <Link to={`/article/${second.id}`} className="group mt-5 grid grid-cols-1 sm:grid-cols-3 gap-0 overflow-hidden rounded-2xl bg-background-900/40 hover:bg-background-900 transition-colors">
            <div className="relative h-48 sm:h-auto sm:col-span-1 overflow-hidden">
              <img src={second.image} alt={second.title} className="absolute inset-0 w-full h-full object-cover" />
            </div>
            <div className="sm:col-span-2 flex flex-col justify-center p-6 md:p-8">
              <span className="text-xs text-accent-300">从时间码说起</span>
              <h3 className="mt-2 font-heading text-lg md:text-xl font-bold text-background-50 leading-snug group-hover:text-accent-200 transition-colors">{second.title}</h3>
              <p className="mt-2 text-sm text-background-100/70 leading-6 line-clamp-2">{second.subtitle}</p>
            </div>
          </Link>
        )}

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-4">
          {methods.map((m) => (
            <div key={m.title} className="rounded-xl border border-background-100/10 bg-background-900/40 p-5 flex gap-3.5">
              <span className="flex items-center justify-center w-10 h-10 shrink-0 rounded-lg bg-accent-500/20 text-accent-300">
                <i className={`${m.icon} text-lg`}></i>
              </span>
              <div>
                <h4 className="font-heading text-base font-semibold text-background-50">{m.title}</h4>
                <p className="mt-1 text-xs leading-5 text-background-100/60">{m.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}